'use client';

import { useCurrentUser } from '@ianesthesie-kit/redux';
import { useHospitalById } from './hospital.slice';
import { skipToken } from '@reduxjs/toolkit/query';
import { useCallback, useEffect, useState } from 'react';
import { HospitalService } from './hospital.service';
import { AppConfigService } from '@/config';

export const useCurrentHospital = (opts?: { skip?: boolean }) => {
  const user = useCurrentUser();
  const [jwtHospitalId, setJwtHospitalId] = useState(() =>
    HospitalService.getInstance().getHospitalIdFromJwt()
  );

  const { refetch: rtkRefetch, ...queryResult } = useHospitalById(
    jwtHospitalId ?? skipToken,
    {
      skip: !user || !!opts?.skip
    }
  );

  const refresh = useCallback(() => {
    setJwtHospitalId(HospitalService.getInstance().getHospitalIdFromJwt());
  }, []);

  const refetch = useCallback(() => {
    refresh();
    return rtkRefetch();
  }, [refresh, rtkRefetch]);

  useEffect(() => {
    refresh();
  }, [user?.id, refresh]);

  useEffect(() => {
    if (queryResult.data) {
      AppConfigService.getInstance().setCurrentHospital(queryResult.data);
    }
  }, [queryResult.data]);

  return {
    refresh,
    queryResult: {
      ...queryResult,
      refetch
    }
  };
};
